import { routeHandler } from "./lib/routeHandlers";
import { Model, Query, Data, Id } from "../lib/typeDeclarations";
import server from "./lib/fetchRequests";
const Server = new server();

export const listRecords = async (model: Model, query: Query) => {
  const URL = routeHandler(model);
  const queryString = ["?"];

  if (query) {
    for (const item of Object.keys(query)) {
      if (Array.isArray(query[item])) {
        query[item].map((i: any) => {
          query[item] !== null && queryString.push(`${item}=${i}&`);
        });
      } else {
        query[item] !== null && queryString.push(`${item}=${query[item]}&`);
      }
    }
  }

  const response = await Server.get(URL + queryString.join("").substring(0, queryString.join("").length - 1));
  return response.data;
};

export const findRecordById = async (model: Model, id: Id) => {
  const URL = routeHandler(model);
  const response = await Server.get(URL + "/" + id);
  return response.data;
};

export const createRecord = async (model: Model, data: Data) => {
  const URL = routeHandler(model);
  const response = await Server.post(URL, data);
  return response.data;
};

export const updateRecord = async (model: Model, id: Id, data: Data) => {
  const URL = routeHandler(model);
  const response = await Server.put(URL + "/" + id, data);
  return response.data;
};

export const deleteRecord = async (model: Model, id: Id) => {
  const URL = routeHandler(model);
  const response = await Server.delete(URL + "/" + id);
  return response.data;
};

export const deleteRecords = async (model: Model, data: Data) => {
  const URL = routeHandler(model);
  const response = await Server.delete(URL, data);
  return response.data;
};

export const sendEmail = async (model: Model, id: Id, template: string) => {
  const URL = routeHandler(model);
  const response = await Server.post(URL + "/" + id + "/" + template);
  return response.status;
};

export const login = async (model: Model, credentials: Data) => {
  const URL = routeHandler(model);
  const response = await Server.post(URL + "/login", credentials);
  if (response.data.credentials) {
    const userData = response.data.credentials;
    const user = {
      id: userData.id,
      username: userData.username,
      email: userData.email,
      role: userData.role,
      theme: userData.theme,
      theme_color_hs: userData.theme_color_hs,
    };
    document.cookie = `user=${encodeURIComponent(JSON.stringify(user))}; path=/;`;
  }
  return response.data;
};

export const logOut = async () => {
  const response = await Server.get("/auth/logout");
  document.cookie = `user=`;
  return response.data;
};
